import { makeQuery } from 'shared/utilities';

export const notificationsClearQuery = async function () {
    return await makeQuery<ResponseType>('/notifications/clear', { method: "POST" });
}
